import React from "react";
import "./radioButton.css";

type Props = {
  id: string;
  name: string;
  checked: boolean;
  onChange: (id: string, value: boolean) => void;
  label?: string;
  style?: React.CSSProperties;
  className?: string;
  color?: "default" | "alternate";
  disabled?: boolean;
};
const RadioButton = ({
  id,
  name,
  checked,
  onChange = () => {},
  label,
  style = {},
  className,
  color = "default",
  disabled = false,
}: Props) => {
  return (
    <label className={"rb-container " + className} id={id} style={{ ...style }}>
      {label}
      <input
        type="radio"
        name={name}
        checked={checked}
        onChange={(e) => onChange(id, e.target.checked)}
        disabled={disabled}
      />
      <span className={color === "alternate"? "rb-checkmark rb-blue" : "rb-checkmark"} />
    </label>
  );
};

export default RadioButton;
